/** Espace insécable (U+00A0), utilisé entre le nombre et le symbole "%". */
const NBSP = String.fromCharCode(160);

/**
 * Formate un taux de réussite (ratio 0-1) pour l'affichage.
 * - `null`/`undefined` (moins de 5 répondants, ou champ absent de la réponse) → "--"
 * - toute valeur non numérique finie → "--" (évite "NaN %")
 * - sinon → pourcentage arrondi à l'entier suivi d'un espace insécable et de "%"
 *   (ex. 0.75 → "75 %")
 */
export function formatSuccessRate(rate: number | null | undefined): string {
  if (typeof rate !== "number" || !Number.isFinite(rate)) return "--";
  return `${Math.round(rate * 100)}${NBSP}%`;
}
